import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

import { IPartnersCompleteness } from '../planning/models/IPartnersCompleteness'

import { ISPJBPResponse } from './models/ISPJBPResponse'

export const fetchPartnersCompleteness = async <T>(
  partnersCompleteness: IPartnersCompleteness
): Promise<ISPJBPResponse<T>> => {
  const url = proxy(`/webservice/197/sp/v3/spJBPComposedReportCompletedPartners/call`)

  const payload = {
    'p.GUID': partnersCompleteness.reportGuid,

    'p.ProgramType': partnersCompleteness.programType,
    'p.FYear': partnersCompleteness.fYear,
    'p.FQuarter': partnersCompleteness.fQuarter,
    'p.Category': partnersCompleteness.category,
    'p.SubCategory': partnersCompleteness.subCategory,
    'p.L3Category': partnersCompleteness.l3Category,
    'p.IsActuals': partnersCompleteness.isActuals,
    'p.IsTargets': partnersCompleteness.isTargets,
    'p.IsSob': partnersCompleteness.isSob,

    'p.IsAcknowledged': partnersCompleteness.isAcknowledged,
    'p.IsCompleted': partnersCompleteness.isCompleted,
  }

  const { app } = appGetState()
  const [accessToken] = await getTokens(app.ownerId)
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const response = await Rest.post({ url, payload, headers })

  return response
}
